import * as React from "react";
import { FC, useEffect, useState } from "react";
import { Language, LocalStorageKey } from "../../../data/constants";
import { CustomAutocomplete } from "../customAutocomplete/CustomAutocomplete";
import { IBaseSelectProps } from "./IBaseSelectProps";
import { IOption } from "./IOption";

export interface IMultiLanguageOption {
  labelDE: string;
  labelEN: string;
  labelFR: string;
  labelIT: string;
  value: string;
}

interface IMultiLanguageSelectProps extends IBaseSelectProps<string, string | undefined> {
  label: string;
  defaultValue?: string;
  options: IMultiLanguageOption[];
}

export const MultiLanguageSelect: FC<IMultiLanguageSelectProps> = ({
  options,
  defaultValue,
  value,
  onChange = (_value?: string) => { },
  ...props
}) => {
  const [inputOptions, setInputOptions] = useState<IOption[]>([]);
  const language = localStorage.getItem(LocalStorageKey.LastSelectedLanguageKey);

  useEffect(() => {
    var unsortedOptions = options.map((option) => {
      let label = option.labelDE;
      switch (language) {
        case Language.EN:
          label = option.labelEN;
          break;
        case Language.FR:
          label = option.labelFR;
          break;
        case Language.IT:
          label = option.labelIT;
          break;
      }

      return {
        label: label,
        value: option.value,
      };
    });
    const sortedOptions = unsortedOptions.sort((a, b) => a.label.localeCompare(b.label));
    setInputOptions(sortedOptions);
  }, [options, language]);

  const defaultOption = inputOptions.find((option) => option.value === defaultValue) || null;
  const selectedOption = inputOptions.find((option) => option.value === value) || null;
  return (
    <CustomAutocomplete
      {...props}
      options={inputOptions}
      getOptionLabel={(option) => option.label}
      defaultValue={defaultOption}
      value={selectedOption}
      onChange={(_event, value) => onChange(value?.value)}
    />
  );
};
